import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import UtilsService from '@/core/services/utils.service';
import TokenService from '@/core/services/token.service';

import '@/styles/iconFonts/style.css';
import '@/assets/external-fonts/style.css';

Vue.config.productionTip = false;

Vue.config.silent = true

// TokenService.get() devuelve null si el token caducó y lo descarta. La
// cabecera ya no se asigna aquí: la pone el interceptor de http.service en
// cada petición. La línea anterior (`axios.defaults...`) nunca llegó a surtir
// efecto, porque escribía en la instancia global de axios y no en `$http`
// —axios.create() copia los defaults— y además omitía el prefijo `Token `.
if (localStorage.getItem('user-token')) {
  if (!TokenService.get()) {
    store.dispatch('authLogout');
  }
  const openNavbarString = localStorage.getItem('open-navbar');
  if (openNavbarString !== null) {
    const openNavbar = openNavbarString === 'true';
    store.dispatch('setOpenNavbar', openNavbar);
  }
}

Vue.use(VueAxios, axios);

import * as Sentry from '@sentry/browser';

if (!UtilsService.inDebug()) {
  Sentry.init({
    dsn: 'https://fd519075cbda4fa9b55aa85cd0625019@sentry.io/1294867',
    integrations: [new Sentry.Integrations.Vue({ Vue })],
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
